export const styles = {
  agendaItemModal: {
    "& .MuiDialogTitle-root": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "baseline",
      padding: "22px 24px 16px",
    },
    "& .MuiTextField-root": {
      marginBottom: "1rem",
    },
    "& .MuiDialogContent-root": {
      paddingTop: "0.875rem",
      gap: "20px",
      display: "flex",
      flexDirection: "column",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(0)",
      marginBottom: "12px",
      position: "relative",
    },
    "& input.MuiOutlinedInput-input": {
      padding: "14px",
    },
    "& legend": {
      display: "none",
    },
    "& .MuiFormHelperText-contained": {
      marginLeft: 0,
    },
    "& .MuiDialogActions-root": {
      borderTop: "1px solid #ededed",
      display: "flex",
      justifyContent: "space-between",
      padding: "1rem 1.5rem 1.5rem",
    },
  },
  twoCol: {
    display: "flex",
    justifyContent: "space-between",
  },
  naColor: {
    width: "250px",
    "& label": {
      // This would target a <label> element if one existed inside the Box
      marginBottom: "8px",
    },
  },
  deleteBtn: {
    "&:hover": {
      color: "#f50057",
    },
    "& svg": {
      marginRight: "7px",
    },
  },
};
